// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-screen-description .cancel-container {
  margin-top: 12px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}

.payment-screen-description .cancel-container .cancel-item {
  margin-top: 12px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}

.payment-screen-description .cancel-container .cancel-item .text {
  margin-left: 11px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.payment-screen-description .safe-info-block {
  padding-top: 12px;
  margin-top: 40px;
}

.payment-screen-description .safe-info-block .title {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 8px;
}

.payment-screen-description .safe-info-block .text {
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.payment-screen-description.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".payment-screen-description .cancel-container {\n  margin-top: 12px;\n  margin-bottom: 32px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.payment-screen-description .cancel-container .cancel-item {\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.payment-screen-description .cancel-container .cancel-item .text {\n  margin-left: 11px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.payment-screen-description .safe-info-block {\n  padding-top: 12px;\n  margin-top: 40px;\n}\n\n.payment-screen-description .safe-info-block .title {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n\n.payment-screen-description .safe-info-block .text {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: normal;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
